<script lang="ts">
import SectionSalarieInformations from '@/generated/sections/SectionSalarieInformations.vue';
import Contrat from '@/generated/classes/Contrat';
import { ExtendValid } from '@/framework/base/helpers/ExtendValid';
import { defineComponent, type PropType } from "vue";

export default defineComponent({
  components: {},
  extends: SectionSalarieInformations,
  props: {
    contrat: {
      type: Object as PropType<Contrat>
    }
  },
  methods: {
    isDisplayed(value: string): boolean {
      let res = true;
      if (this.displayMap.size == 0) {
        const requiredAttributs = this.getRequiredAttributs();
        this.displayMap.set("PSEUDO", this.requiredMissing(requiredAttributs, "PSEUDO") || !!this.fiche);
        this.displayMap.set("EMPLOI_ID", this.requiredMissing(requiredAttributs, "EMPLOI_ID") || !!this.fiche);
        this.displayMap.set("STATUT_HANDICAP", this.requiredMissing(requiredAttributs, "STATUT_HANDICAP") || !!this.fiche);
        this.displayMap.set("DATE_HANDICAP", this.editSalarie.statutHandicap > 0 && (this.editSalarie.dateHandicap == null || !!this.fiche));
        this.displayMap.set("NUMERO_CONGE_SPEC", this.requiredMissing(requiredAttributs, "NUMERO_CONGE_SPEC") || !!this.fiche);
      }
      const display = this.displayMap.get(value);
      if (display != undefined) {
        res = display;
      }
      return res;
    },
    isRequired(value: string): boolean {
      let res = true;
      const requiredAttributs = this.getRequiredAttributs();
      if (this.requiredMap.size == 0) {
        this.requiredMap.set("PSEUDO", this.requiredMissing(requiredAttributs, "PSEUDO") || !this.fiche);
        this.requiredMap.set("EMPLOI_ID", this.requiredMissing(requiredAttributs, "EMPLOI_ID") || !this.fiche);
        this.requiredMap.set("STATUT_HANDICAP", this.requiredMissing(requiredAttributs, "STATUT_HANDICAP") || !this.fiche);
        this.requiredMap.set("DATE_HANDICAP", this.editSalarie.statutHandicap > 0 && !this.fiche);
        this.requiredMap.set("NUMERO_CONGE_SPEC", this.requiredMissing(requiredAttributs, "NUMERO_CONGE_SPEC") || !this.fiche);
      }
      const required = this.requiredMap.get(value);
      if (required != undefined) {
        res = required;
      }
      return res;
    },
    fieldUpdated(field: string, value: unknown): void {
      if (field == 'NUMERO_CONGE_SPEC') {
        let numero = value as string;
        if (ExtendValid.isValidCongeSpecSalarie(numero)) {
          numero = numero.replaceAll(' ', '');
          if (numero.length == 7) {
            numero = numero.slice(0, 1) + '0' + numero.slice(1);
          }
          if (numero.length == 8) {
            numero = numero.slice(0, 1) + ' ' + numero.slice(1, 4) + ' ' + numero.slice(4);
            if (this.editSalarie.numeroCongeSpec != numero) {
              this.editSalarie.numeroCongeSpec = numero;
            }
          }
        }
      } else if (field == "STATUT_HANDICAP") {
        this.requiredMap.clear();
        this.displayMap.clear();
      }
    }
  }
})

</script>
